module.exports = __webpack_public_path__ + "static/img/bg2_.a5f9049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/UserLogin/bg2_.png
// module id = GVra
// module chunks = 1